<template>
  <div class="col-xl-3 col-sm-6 mb-xl-0 mb-4">
    <div class="card">
      <div class="card-body p-3">
        <div class="row">
          <div class="col-8">
            <div class="numbers">
              <p class="text-sm mb-0 text-uppercase font-weight-bold">{{ title }}</p>
              <h5 class="font-weight-bolder" :class="[color]">
                {{
                  value
                    | currency("R$ ", 2, {
                      thousandsSeparator: ".",
                      decimalSeparator: ",",
                    })
                }}
              </h5>
            </div>
          </div>
          <div class="col-4 text-end">
            <div class="icon icon-shape shadow-primary text-center rounded-circle" :class="[background]">
              <i class="text-lg opacity-10 white" :class="[icon]" aria-hidden="true"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ColumnDataValueTotal',
    props: ['title', 'value', 'icon', 'background', 'color']
  }
</script>